import { useTranslation } from "react-i18next";
import { useRowPagination } from "hooks/useRowPagination";
import { useSelector } from "react-redux";
import { RxCaretDown } from "react-icons/rx";

import PaymentRow from "./PaymentRow";
import { useState, useMemo } from "react";
import CustomerRowPagination from "components/General/CustomerRowPagination";

export default function PaymentHistoryTab({ data }) {
  const { t } = useTranslation();
  const { policies } = useSelector((state) => state.data);
  const [sortConfig, setSortConfig] = useState({
    key: "postedDate",
    direction: "desc",
  });

  const requestSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const { rowsForDisplay: current, rowPaginationProps: paginationProps } =
    useRowPagination(data, [5, 10, 25, "all"]);

  const sortedCurrent = useMemo(() => {
    const sortFunctions = {
      postedDate: (a, b) => new Date(a.postedDate) - new Date(b.postedDate),
      amount: (a, b) =>
        parseFloat(a.amount.replace(/[^0-9.-]+/g, "")) -
        parseFloat(b.amount.replace(/[^0-9.-]+/g, "")),
      type: (a, b) => a.type.localeCompare(b.type),
    };

    return [...current].sort((a, b) => {
      const sortFunction = sortFunctions[sortConfig.key];
      return sortConfig.direction === "asc"
        ? sortFunction(a, b)
        : sortFunction(b, a);
    });
  }, [current, sortConfig]);

  return (
    <>
      {data.length > 0 ? (
        <>
          {current.find((ph) => ph.type === "Disbursed") && (
            <h3 className="text-right mt-4">
              {t("AuthCustomerBilling-important-infoText")}
            </h3>
          )}
          <div className="ui-card-bar relative mt-4">
            <div className="px-3 py-2">
              <div className="grid grid-cols-1 md:grid-cols-6 gap-2 xl:gap-2">
                <div className="text-sm font-bold text-theme-text-secondary md:col-span-2">
                  Contract Number
                </div>
                <div
                  className="flex items-center text-sm font-bold text-theme-text-secondary md:col-span-1 cursor-pointer"
                  onClick={() => requestSort("amount")}
                >
                  Amount
                  <span>
                    <RxCaretDown
                      style={{
                        transform: `${
                          sortConfig.key === "amount" &&
                          sortConfig.direction === "asc"
                            ? "rotate(180deg)"
                            : ""
                        }`,
                      }}
                      size={23}
                    />
                  </span>
                </div>
                <div className="text-sm font-bold text-theme-text-secondary md:col-span-1">
                  Method
                </div>
                <div
                  className="flex items-center text-sm font-bold text-theme-text-secondary md:col-span-1 cursor-pointer"
                  onClick={() => requestSort("type")}
                >
                  Status
                  <span>
                    <RxCaretDown
                      style={{
                        transform: `${
                          sortConfig.key === "type" &&
                          sortConfig.direction === "asc"
                            ? "rotate(180deg)"
                            : ""
                        }`,
                      }}
                      size={23}
                    />
                  </span>
                </div>
                <div
                  className="flex items-center text-sm font-bold text-theme-text-secondary md:col-span-1 cursor-pointer"
                  onClick={() => requestSort("postedDate")}
                >
                  Date Received
                  <span>
                    <RxCaretDown
                      style={{
                        transform: `${
                          sortConfig.key === "postedDate" &&
                          sortConfig.direction === "asc"
                            ? "rotate(180deg)"
                            : ""
                        }`,
                      }}
                      size={23}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>

          {sortedCurrent.map((b) => {
            return (
              <PaymentRow
                key={`payment row - ${JSON.stringify(b)}`}
                data={b}
                type="history"
                policies={policies}
                hasStatement={false}
              />
            );
          })}

          <CustomerRowPagination {...paginationProps} />
        </>
      ) : (
        <div className="border border-dashed border-ui-gray p-6 my-6">
          <div className="text-center">
            <div className="text-xl font-bold">
              {t("AuthCustomerBilling-no-result-title")}
            </div>
            <div className="mt-1 text-theme-text-quaternary text-sm">
              {t("AuthCustomerBilling-no-result-subtitle")}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
